import { render, staticRenderFns } from "./MaxBidButton.vue?vue&type=template&id=7b4d994c&"
import script from "./MaxBidButton.vue?vue&type=script&lang=js&"
export * from "./MaxBidButton.vue?vue&type=script&lang=js&"
import style0 from "./MaxBidButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports